import React, { useState, useEffect } from "react";
import {
    Button,
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    Typography,
    IconButton,
    Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import MenuBookIcon from "@mui/icons-material/MenuBook";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import PhoneIcon from "@mui/icons-material/Phone";

interface ModalProps {
    props: {
        modalOpen: boolean;
        setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    };
}

const HelpContactModal: React.FC<ModalProps> = ({ props }) => {
    // ページ管理
    const [tabValue, setTabValue] = useState(0);
    // モーダルヘッダータイトル
    const [modalTitle, setModalTitle] = useState("");

    // ページ切り替え
    const handleTabChange = (newValue: number) => {
        setTabValue(newValue);
    };

    // 戻るボタン押下時
    const handleBackTab = () => {
        setTabValue(0);
    };

    // モーダルクローズ
    const handleClose = () => {
        props.setModalOpen(false);
        setTabValue(0);
    };

    // タイトルセット処理
    useEffect(() => {
        if(tabValue === 1) {
            setModalTitle("立地調査デジタルについて");
        } else if (tabValue === 2) {
            setModalTitle("調査内容について");
        } else if (tabValue === 3) {
            setModalTitle("調査書に関するご要望");
        } else {
            setModalTitle("ヘルプ・お問い合わせ");
        }
    },[tabValue]);
    
    return (
        <Dialog
            open={props.modalOpen}
            onClose={handleClose}
            fullWidth
            maxWidth="md"
        >
            {/* ヘッダー */}
            <DialogTitle sx={{
                textAlign: "center",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #e0e0e0"
            }}>
                {tabValue !== 0 ? (
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={handleBackTab}
                        aria-label="close"
                    >
                        <ArrowBackIcon />
                    </IconButton>
                ):(
                    <Box></Box>
                )}
                <Typography variant="h6" component="div">
                    {modalTitle}
                </Typography>
                <IconButton
                    edge="end"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close"
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            {/* コンテンツ */}
            <DialogContent sx={{ p: 0 }}>
                {/* ヘルプ・問い合わせ選択画面 */}
                {tabValue === 0 && (
                    <Box>
                        <Box 
                            sx={{
                                display: 'flex', 
                                flexDirection: 'column',
                                alignItems: 'center',
                                borderBottom: '1px solid #e0e0e0',
                                padding: '10px'
                            }}
                        >
                            <Button
                                onClick={() => handleTabChange(1)}
                                fullWidth
                                sx={{
                                    margin: '10px 0',
                                    padding: '10px 20px',
                                    borderRadius: '4px',
                                    maxWidth: '80%',
                                    textAlign: 'left',
                                    justifyContent: 'flex-start',
                                    backgroundColor: '#f5f5f5',
                                    color: 'inherit',
                                    borderLeft: '4px solid #00CC5B',
                                    '&:hover': {
                                        backgroundColor: '#cfcfcfff'
                                    }
                                }}
                            >
                                立地調査デジタルについての問い合わせ
                            </Button>
                            <Button
                                onClick={() => handleTabChange(2)}
                                fullWidth
                                sx={{
                                    margin: '10px 0',
                                    padding: '10px 20px',
                                    borderRadius: '4px',
                                    maxWidth: '80%',
                                    textAlign: 'left',
                                    justifyContent: 'flex-start',
                                    backgroundColor: '#f5f5f5',
                                    color: 'inherit',
                                    borderLeft: '4px solid #00CC5B',
                                    '&:hover': {
                                        backgroundColor: '#cfcfcfff'
                                    }
                                }}
                            >
                                調査内容についての問い合わせ
                            </Button>
                            <Button
                                onClick={() => handleTabChange(3)}
                                fullWidth
                                sx={{
                                    margin: '10px 0',
                                    padding: '10px 20px',
                                    borderRadius: '4px',
                                    maxWidth: '80%',
                                    textAlign: 'left',
                                    justifyContent: 'flex-start',
                                    backgroundColor: '#f5f5f5',
                                    color: 'inherit',
                                    borderLeft: '4px solid #00CC5B',
                                    '&:hover': {
                                        backgroundColor: '#cfcfcfff'
                                    }
                                }}
                            >
                                調査書に関するご要望
                            </Button>
                        </Box>
                    </Box>
                )}
                {/* 立地調査について */}
                {tabValue === 1 && (
                    <Box>
                        <Box
                            sx={{
                                display: 'flex', 
                                flexDirection: 'column',
                                alignItems: 'center',
                                borderBottom: '1px solid #e0e0e0',
                                padding: '10px'
                            }}
                        >
                            <Box
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}
                            >
                                <Button
                                    variant='outlined'
                                    sx={{
                                        width: '100%',
                                        maxWidth: '30%',
                                        padding: '10px 5px',
                                        borderRadius: '4px',
                                        display: 'block',
                                        textAlign: 'center',
                                        backgroundColor: '#f5f5f5',
                                        color: 'inherit',
                                        '&:hover': {
                                            backgroundColor: '#cfcfcfff'
                                        }
                                    }}
                                    onClick={() => { window.open(process.env.REACT_APP_MANUAL_LINK); }}
                                >
                                    <Box><MenuBookIcon sx={{color: '#3c9bf9'}}/></Box>
                                    <Typography>マニュアル</Typography>
                                    <Box><OpenInNewIcon sx={{fontSize: '15px'}}/></Box>
                                </Button>
                                <Button
                                    variant='outlined'
                                    sx={{
                                        width: '100%',
                                        maxWidth: '30%',
                                        margin: '0px 14px 0px 14px',
                                        padding: '10px 5px',
                                        borderRadius: '4px',
                                        display: 'block',
                                        textAlign: 'center',
                                        backgroundColor: '#f5f5f5',
                                        color: 'inherit',
                                        /* '&:hover': {
                                            backgroundColor: '#cfcfcfff'
                                        } */
                                    }}
                                    disabled={true}
                                    /* onClick={() => { window.open(process.env.REACT_APP_FAQ_LINK); }} */
                                >
                                    {/* <Box><HelpOutlineIcon sx={{color: '#00CC5B'}}/></Box> */}
                                    <Typography>Q&A（準備中）</Typography>
                                    <Box><OpenInNewIcon sx={{fontSize: '15px'}}/></Box>
                                </Button>
                                <Button
                                    variant='outlined'
                                    sx={{
                                        width: '100%',
                                        maxWidth: '30%',
                                        padding: '10px 5px',
                                        borderRadius: '4px',
                                        display: 'block',
                                        textAlign: 'center',
                                        backgroundColor: '#f5f5f5',
                                        color: 'inherit',
                                        '&:hover': {
                                            backgroundColor: '#cfcfcfff'
                                        }
                                    }}
                                    onClick={() => { window.open(process.env.REACT_APP_FAQ_LINK); }}
                                >
                                    <Box><HelpOutlineIcon sx={{color: '#00CC5B'}}/></Box>
                                    <Typography>チャット問い合わせ</Typography>
                                    <Box><OpenInNewIcon sx={{fontSize: '15px'}}/></Box>
                                </Button>
                            </Box>
                            <Box
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    paddingTop: '2%'
                                }}
                            >
                                <Paper
                                    variant='outlined'
                                    sx={{
                                        width: '100%',
                                        maxWidth: '92%',
                                        padding: '10px 5px',
                                        borderRadius: '4px',
                                        display: 'block',
                                        textAlign: 'center',
                                        backgroundColor: '#f5f5f5',
                                        color: 'inherit'
                                    }}
                                >
                                    <Box sx={{justifyContent: 'center'}}>
                                        <PhoneIcon sx={{color: '#3c9bf9'}}/>
                                    </Box>
                                    <Typography>電話問い合わせ・・・専用内線 48937</Typography>
                                </Paper>
                            </Box>
                        </Box>
                    </Box>
                )}
                {/* 調査内容について */}
                {tabValue === 2 && (
                    <Box>
                        <Box
                            sx={{
                                display: 'flex', 
                                flexDirection: 'column',
                                alignItems: 'center',
                                borderBottom: '1px solid #e0e0e0',
                                padding: '10px'
                            }}
                        >
                            <Box
                                sx={{
                                    width: '97%',
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}
                            >
                                <Button
                                    variant='outlined'
                                    sx={{
                                        width: '100%',
                                        maxWidth: '87.3%',
                                        margin: '10px 0px',
                                        alignItem: 'center',
                                        justifyContent: 'center',
                                        padding: '10px 20px',
                                        borderRadius: '4px',
                                        display: 'flex',
                                        textAlign: 'center',
                                        backgroundColor: '#f5f5f5',
                                        color: 'inherit',
                                        '&:hover': {
                                            backgroundColor: '#cfcfcfff'
                                        }
                                    }}
                                    onClick={() => { window.open(process.env.REACT_APP_MANUAL_CHECK_LINK); }}
                                >
                                    <Box sx={{marginRight: '10px'}}><MenuBookIcon sx={{color: '#3c9bf9'}}/></Box>
                                    <Typography>マニュアルを確認する</Typography>
                                </Button>
                            </Box>
                            <Paper
                                variant='outlined'
                                sx={{
                                    width: '100%',
                                    maxWidth: '80%',
                                    margin: '10px 0',
                                    padding: '10px 20px',
                                    borderRadius: '4px',
                                    textAlign: 'center',
                                    backgroundColor: '#f5f5f5',
                                    color: 'inherit'
                                }}
                            >
                                <Box sx={{display: 'flex', justifyContent: 'center'}}>
                                    <PhoneIcon/>
                                    <Typography sx={{fontSize: '18px', fontWeight: 'bold'}}>リクルートリサーチ内線番号</Typography>
                                </Box>
                                <Typography sx={{fontSize: '20px', color: '#3c9bf9'}}>03-6238-3792</Typography>
                                <Typography sx={{fontSize: '12px'}}>担当者が不在の場合は伝言を残してください。</Typography>
                            </Paper>
                        </Box>
                    </Box>
                )}
                {/* 調査書に関するご要望 */}
                {tabValue === 3 && (
                    <Box>
                        <Box 
                            sx={{
                                display: 'flex', 
                                flexDirection: 'column',
                                alignItems: 'center',
                                borderBottom: '1px solid #e0e0e0',
                                padding: '10px'
                            }}
                        >
                            <Box
                                sx={{
                                    width: '100%',
                                    display: 'block',
                                    textAlign: 'center'
                                }}
                            >
                                <ChatBubbleOutlineIcon sx={{color: '#b4e7fb', fontSize: '60px', margin: '20px'}}/>
                                <Typography sx={{fontSize: '15px', marginBottom: '10px'}}>電子調査書・調査書に関するご要望は下記Formsにご記入ください。</Typography>
                            </Box>
                            <Button
                                fullWidth
                                sx={{
                                    margin: '10px 0',
                                    padding: '10px 20px',
                                    borderRadius: '4px',
                                    maxWidth: '80%',
                                    textAlign: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#3c9bf9',
                                    color: '#ffffff',
                                    '&:hover': {
                                        backgroundColor: '#111ed0ff'
                                    }
                                }}
                                onClick={() => { window.open(process.env.REACT_APP_REQUEST_FORM_LINK); }}
                            >
                                ご要望フォームを開く
                                <OpenInNewIcon sx={{fontSize: '15px'}}/>
                            </Button>
                        </Box>
                    </Box>
                )}

            </DialogContent>
        </Dialog>
    );
};

export default HelpContactModal;